/*
  {% render 'product-quantity-selector', product: product %}
*/

import formatMoney from '../utils/formatMoney';

const initQuantityInputs = (container = document.querySelector('[data-product-main]')) => {
  const quantitySelectors = container.querySelectorAll('[data-quantity-selector]');

  if (!quantitySelectors.length) return;

  const updateAtcBtnPrice = (selector, qty) => {
    const form = selector.querySelector('input').form;
    const atcButton = form.querySelector('button[type="submit"]');
    const atcButtonPrice = atcButton.querySelector('[data-atc-price]');
    const atcButtonPipe = atcButton.querySelector('[data-atc-price-pipe]');
    const newPrice = formatMoney(Number(selector.dataset.qtySelectorVariantPrice * qty));
    atcButtonPipe.classList.remove('hidden');
    atcButtonPrice.textContent = newPrice;
  };

  const changeInput = (qtyInput, value, selector) => {
    if (qtyInput.checkValidity()) {
      const inputValue = +qtyInput.value;
      const newValue = inputValue + value;
      qtyInput.value = String(newValue);
      updateAtcBtnPrice(selector, + newValue);
    }
  };

  quantitySelectors.forEach(selector => {
    const qtyInput = selector.querySelector('[data-quantity-input]');

    qtyInput.addEventListener('change', () => changeInput(qtyInput, 0, selector));
    selector.addEventListener('click', (evt) => {
      const decBtn = evt.target.closest('[data-quantity-dec]');
      const incBtn = evt.target.closest('[data-quantity-inc]');
      decBtn && +qtyInput.value > 1 ? changeInput(qtyInput, -1, selector) : null;
      incBtn ? changeInput(qtyInput, +1, selector) : null;
    });
  });
};

export default initQuantityInputs;
